export const isLocalhost = () => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  return window.location.hostname === 'localhost';
};
